export enum EventKey {
  CLOSE = 'close',
  SUCCESS = 'success',
  PLAY_VIDEO = 'play-video',
  CONFIG_CHANGE = 'config-option-select-change',
  PACKAGE_APPLY = 'package_apply',
  PACKAGE_OPTION_DETAIL_OPEN = 'package_option_detail_open',
}
